// @ts-nocheck
/**
 * @param {{ message: string }} props
 * The "Account pending" card shown in place of a page's content for a caller whose portal
 * engagement is still Requested. Shared by Change Log and Feature Voting so a pending account
 * sees the identical notice on both (ACOP-118) — only the body copy differs per page.
 */
const PendingAccountNotice = ({ message }) => (
    <div className="copilot-changelog-pending" role="status">
        <div className="d-flex align-items-start gap-2">
            <i className="fa-solid fa-circle-info text-primary mt-1" aria-hidden />
            <div>
                <p className="login-form-title h6 mb-1">Account pending</p>
                <p className="small text-body-secondary mb-0">{message}</p>
            </div>
        </div>
    </div>
);

export default PendingAccountNotice;
